import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=3cfbd94f&scoped=true"
import script from "./Statistics.vue?vue&type=script&setup=true&lang=js"
export * from "./Statistics.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=3cfbd94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbd94f",
  null
  
)

export default component.exports